import { render, staticRenderFns } from "./statisticsBox.vue?vue&type=template&id=3b1a9a77&scoped=true"
import script from "./statisticsBox.vue?vue&type=script&lang=js"
export * from "./statisticsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a9a77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1a9a77')) {
      api.createRecord('3b1a9a77', component.options)
    } else {
      api.reload('3b1a9a77', component.options)
    }
    module.hot.accept("./statisticsBox.vue?vue&type=template&id=3b1a9a77&scoped=true", function () {
      api.rerender('3b1a9a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/enterprise/chart/components/statisticsBox.vue"
export default component.exports